
import Glider from 'glider-js'

export const cardGlider = function() {

    const defaults = {
      exactWidth: false,
      draggable: true,
      scrollLock: true,
      resizeLock: true,
      itemWidth: 400,
      duration: 0.25,
      dots: '.glider-dots',
    };

    const gliderConfigSelector = index => `glider-config-${index}`;

    const getCustomConfig = glider => glider.getAttribute('data-config');

    const getResponsiveConfig = (glider, responsiveConfig) => {
      const custom = getCustomConfig(glider);

      return custom ? JSON.parse(custom): responsiveConfig; 
    }

    const gliderConfig = (glider, index, responsiveConfig) => {
      const gliderSelector = gliderConfigSelector(index);
      const config = { 
        dots: `.${gliderSelector} .glider-dots`.toString(), 
        arrows: {
          prev: `.${gliderSelector} .glider-prev`.toString(),
          next: `.${gliderSelector} .glider-next`.toString()
        },  
      };
      const responsive = getResponsiveConfig(glider, responsiveConfig);

      return {...defaults, ...config, ...{ responsive: responsive } };
    }

    const init = (selector, responsiveConfig) => {

      const gliders = document.querySelectorAll(selector);

      if (gliders) {
        [...gliders].forEach((glider, index) => {
          const gliderSelector = gliderConfigSelector(index);
          const config =  gliderConfig(glider, index, responsiveConfig);
  
          glider.parentNode.classList.add(gliderSelector);
          new Glider(glider, config);  
        });
      }
    };

    return {
        init: init
    };
}